import { Controller } from '@hotwired/stimulus'

export default class BirthInformationController extends Controller {
  static targets = [
    'birthZipInput',
    'birthCountrySelect',
    'birthCityAutocompleteSelect',
  ];

  static values = {
    countryRequiringZipCode: Array,
  };

  connect() {
    this.onCountryChange({ silent: true });

    this.element.addEventListener('autocomplete:ready', () => {
      this.onCountryChange({ silent: true });
    });

    window.addEventListener('change.select2', () => {
      this.onCountryChange();
    });
  }

  onAutocompleteResultSelect(event) {
    const { item } = event.detail;

    this.birthZipInputTarget.value = item?.zip || '';
  }

  onCountryChange(options = {}) {
    if (
      this.countryRequiringZipCodeValue.includes(
        this.birthCountrySelectTarget.value
      )
    ) {
      this._dispatchAutocompleteEvent('autocomplete:enter-select', options);
      this.birthZipInputTarget.required = true;
    } else {
      this._dispatchAutocompleteEvent('autocomplete:enter-free', options);
      this.birthZipInputTarget.required = false;
    }
  }

  _dispatchAutocompleteEvent(eventName, detail = {}) {
    this.birthCityAutocompleteSelectTarget.dispatchEvent(
      new CustomEvent(eventName, { bubbles: true, detail })
    );
  }
}
